import * as api from "~/api/resource";
import _ from "lodash";

export default {
    props: {},
    data() {
        return {
            commonsLoaded: false,
            _value: "",
            id: null,
            workingSapplier: null,
            workingRoute: null,
            // ScheduleTrip: null,
            scheduleTripRequest: null,
            TripServise: null,
            RouteData: null,
            Customer: null,
            Buisness: null,
            workingProduct: null,
        };
    },
    computed: {
        ScheduleTrip() {
            return this.$store.state.ScheduleTrip;
        },
        isDirty() {
            return !!this.$data._value;
        },
    },
    watch: {
        async "formDada.tripid"(v, vo) {
            if (v == vo) return;
            if (!v) return;
            if (!this.ScheduleTrip || this.ScheduleTrip.id != v) {
                const st = await api.fetchObject("scheduletrip", {
                    id: v,
                    with: "TripService",
                });

                this.$set(this.$store.state, "ScheduleTrip", st);
            }
        },
        $route: {
            async handler(to, from) {
                const changed = this.routeChangedFor(to, from);
                // _log_("xaxaxaxa...", to);
                // _log_("xaxaxaxa...", changed);
                if (this.isEmptyObject(changed)) {
                    this.commonsLoaded = true;
                    return;
                }
                this.commonsLoaded = false;
                if (
                    (to.name == "flattransview" || to.name == "tripTransactions") &&
                    changed.params.id
                )
                    if (changed.params.id != "all" && changed.params.id != "null")
                        try {
                            this.Buisness = await api.fetchObject("business", {
                                businessId: to.params.id,
                            });
                        } catch (error) {
                            alert("error loading Buisness:" + to.params.id);
                        }
                    else this.Buisness = null;
                if (!changed.params.productid && !to.params.productid) {
                    // if (changed.params.productid !== undefined)
                    this.workingProduct = null;
                } else {
                    try {
                        if (!this.workingProduc)
                            this.workingProduct = await api.fetchObject("pricerules", {
                                id: to.params.productid,
                            });
                    } catch (error) {
                        alert("error loading pricerules:" + to.params.productid);
                    }
                }

                if (changed.query.selected_customer)
                    try {
                        this.Customer = await api.fetchObject("customers", {
                            id: to.query.selected_customer,
                        });
                    } catch (error) {
                        alert("error loading customer:" + to.query.selected_customer);
                    }
                else this.Customer = null;
                if (changed.query.selected_route)
                    try {
                        this.RouteData = await api.fetchObject("vue_route/getlist", {
                            routename: to.query.selected_route,
                        });
                    } catch (error) {
                        alert("error loading customer:" + to.query.selected_route);
                    }
                else this.RouteData = null;
                if (changed.params.tripServiseId != undefined) {
                    if (to.params.tripServiseId)
                        this.TripServise = await api.fetchObject("tripservice", {
                            id: changed.params.tripServiseId,
                            // forcedb: "travel2",
                        });
                    else this.TripServise = null;
                }
                // _log_(
                //   "xaxaxaxatrip..",
                //   changed,
                //   to.params,
                //   changed.params.tripid
                // );
                if (!to.params.tripid || to.params.tripid == "new") {
                    // _log_("xaxaxaxatrip..cler");
                    this.$set(this.$store.state, "ScheduleTrip", null);
                } else if (
                    !isNaN(changed.params.tripid) &&
                    changed.params.tripid != undefined
                )
                    if (!to.params.tripid || to.params.tripid == "new") {
                        _log_("xaxaxaxatrip..cler");
                        this.$set(this.$store.state, "ScheduleTrip", null);
                    } else if (
                        changed.params.tripid &&
                        (!this.ScheduleTrip ||
                            this.ScheduleTrip.id != changed.params.tripid)
                    )
                        try {
                            _log_("xa go ..", changed.params.tripid);
                            const st = await api.fetchObject("scheduletrip", {
                                id: changed.params.tripid,
                                with: "TripService",
                            });

                            this.$set(this.$store.state, "ScheduleTrip", st);
                            _log_("xa store go ..", st, this.$store.state.ScheduleTrip);
                            // this.$store.state
                        } catch (error) {
                            console.error(error);
                            alert("error loading ScheduleTrip:" + changed.params.tripid);
                        }
                this.commonsLoaded = true;
            },
            immediate: true,
        },
        // "$route.params.productid": {
        //   async handler(id, old_id) {
        //     // _log_('xaxaxaxa',id)
        //     if (!id) {
        //       this.workingProduct = null;
        //       return;
        //     }
        //     if (id == old_id) return;
        //     try {
        //       this.workingProduct = await api.fetchObject("pricerules", {
        //         id: id
        //       });
        //     } catch (error) {
        //       alert("error loading pricerules:" + val);
        //     }
        //   },
        //   immediate: true
        // },
        // "$route.query.selected_customer": {
        //   async handler(id, old_id) {
        //     // _log_('xaxaxaxa',id)
        //     if (!id) return;
        //     if (id == old_id) return;
        //     try {
        //       this.Customer = await api.fetchObject("customers", {
        //         id: id
        //       });
        //     } catch (error) {
        //       alert("error loading pricerules:" + val);
        //     }
        //   },
        //   immediate: true
        // },
        // "$route.params.tripid": {
        //   async handler(id, old_id) {
        //     _log_("xaxaxaxa", id);
        //     if (!id || isNaN(id)) return;
        //     if (id == old_id || (this.ScheduleTrip && this.ScheduleTrip.id == id))
        //       return;
        //     try {
        //       this.ScheduleTrip = await api.fetchObject("ScheduleTrip", {
        //         id: id,
        //         ...this.scheduleTripRequest
        //       });
        //     } catch (error) {
        //       alert("error loading ScheduleTrip:" + id);
        //     }
        //   },
        //   immediate: true
        // }
    },
    methods: {
        async getVehicles(vtype, force) {
            vtype = vtype ? vtype : "all";
            let data = this.$store.state["Vehicles_" + vtype];
            if (!data || force) {
                data = await api.getModxList("assets", {
                    limit: 0,
                    type: vtype == "all" ? null : vtype,
                });
                this.$set(this.$store.state, "Vehicles_" + vtype, data);
            }
            return data.map(v => {
                v.fullName = v.name + ' (' + v.type + (v.vgroup ? '/' + v.vgroup : '') + ')'
                return v
            });
        },
        async getPups(pupType, force) {
            pupType = pupType ? pupType : "all";
            let data = this.$store.state["Pups_" + pupType];
            if (!data || force) {
                data = await api.getModxList("pup", {
                    limit: 0,
                    type: pupType == "all" ? null : pupType,
                });
                let indexedLocs = {}, indexedPups = {}
                data.forEach(pup => {
                    indexedLocs[pup.loc_id] = {name: pup.loc_name, code: pup.loc_code}
                    indexedPups[pup.id] = pup
                })
                this.$set(this.$store.state, "Pups_" + pupType, data);
                this.$set(this.$store.state, "LocsIndex", indexedLocs);
                this.$set(this.$store.state, "PupsIndex", indexedPups);
            }
            return data;
        },
        async getTripServices(force) {

            let data = this.$store.state["tripservices"];
            if (!data || force) {
                data = await api.getModxList("tripservice", {
                    limit: 0,

                });
                this.$set(this.$store.state, "tripservices", data);
            }
            return data;
        },
        routeChangedFor(into, infrom) {
            const to = into
                ? {
                    name: into.name,
                    params: JSON.parse(JSON.stringify(into.params)),
                    query: JSON.parse(JSON.stringify(into.query)),
                }
                : null;
            const from = infrom
                ? {
                    name: infrom.name,
                    params: JSON.parse(JSON.stringify(infrom.params)),
                    query: JSON.parse(JSON.stringify(infrom.query)),
                }
                : infrom;
            var changes = {};
            if (!from) return to;
            if (to.name != from.name) changes.name = to.name;
            if (to.query && !from.query) changes.query = to.query;
            else {
                changes.query = {};
                for (const key in to.query) {
                    if (to.query.hasOwnProperty(key)) {
                        if (to.query[key] != from.query[key])
                            changes.query[key] = to.query[key];
                    }
                }
                for (const key in from.query) {
                    if (from.query.hasOwnProperty(key)) {
                        if (to.query[key] != from.query[key]) changes.query[key] = null;
                    }
                }
            }
            if (to.params && !from.params) changes.params = to.params;
            else {
                changes.params = {};
                for (const key in to.params) {
                    if (to.params.hasOwnProperty(key)) {
                        if (to.params[key] != from.params[key])
                            changes.params[key] = to.params[key];
                    }
                }
                for (const key in from.params) {
                    if (from.params.hasOwnProperty(key)) {
                        if (
                            !changes.params[key] === undefined &&
                            to.params[key] != from.params[key]
                        )
                            changes.params[key] = null;
                    }
                }
            }
            return changes;
        },
        async updateCommon(classType, val) {
            const msg = this.$message({
                showClose: true,
                message: "please wait...updating",
                type: "warning",
                duration: 0,
            });
            const classData = {ScheduleTrip: this.ScheduleTrip};
            const data = await api.updateProcessor(
                classType + "/update",
                classData[classType]
            );
            msg.close();
            this.$emit("something-changed", {classType: classType, payload: data});
        },
        init() {
        },
    },
    mounted() {
    },
};
